<template>
    <div>
        <model-treeselect
            :organization="organization"
            :url="`${url}${extraUrl}`"
            :multiple="multiple"
            v-model="selected_id"
            :placeholder="placeholder ? placeholder : ''"
            :disabled="busy || disabled"
            :filter="filter"
            @add="onAdd"
            @order="onOrder"
            @modify="onModify"
            @addChild="onAddChild"
            @delete="onDelete"
            @loaded="$emit('loaded', $event)"
            :showChildAdd="showChildAdd"
            :showAdd="showAdd"
            :showReorder="showReorder"
            ref="selectModel"
            class="dynamic-select"
        ></model-treeselect>

        <b-modal
            :id="`${id}-dynamic-select-modal`"
            :title="trans(type)"
            :ok-title="trans('save')"
            :ok-disabled="busy"
            :cancel-title="trans('cancel')"
            @ok="onSave"
        >
            <DynamicFormObj
                :organization="organization"
                :fields="fields"
                v-model="currentItem"
                :validation="validation"
                ref="dynamicForm"
            ></DynamicFormObj>
        </b-modal>

        <ReorderModal
          :id="`${id}-dynamic-select-order-modal`"
          :get-url="`${url}/list?per_page=100`"
          :save-url="`${url}/reorder`"
          @saved="onReordered"
        ></ReorderModal>

        <p v-if="error" class="text-danger">
            {{ error }}
        </p>
    </div>

</template>
<style>
    .form-group .dynamic-select .vue-treeselect__input{
        padding-top: 0.375rem;
        padding-bottom: 0.375rem;
    }
    .form-group .dynamic-select .vue-treeselect__control{
        border: 1px solid #b1bace;
    }
</style>
<script>
    import ModelTreeselect from './ModelTreeselect'
    import ReorderModal from './ReorderModal'

    export default {
      name: 'DynamicSelect',
      props: {
        organization: Object,
        filter: Array,
        id: {
            type: String,
            default: 'dynamic-select',
        },
        deleteMsg: {
            type: String,
            default: null,
        },
        type: {
          type: String,
          default: '',
        },
        extraUrl: {
          type: String,
          default: '/list?per_page=10000',
        },
        value: {
            type: Array | Number,
            default: 0
        },
        url: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: null
        },
        type: {
            type: String,
            default: ''
        },
        extraData: {
            type: Object,
            default(){
                return {};
            }
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        showChildAdd: {
            type: Boolean,
            default: false,
        },
        showAdd: {
            type: Boolean,
            default: false,
        },
        showReorder: {
            type: Boolean,
            default: true,
        },
        validation: {
            type: Boolean,
            default: false,
        },
        fields: {
            type: Array | Object,
            default(){
                return [];
            }
        },
        multiple: {
            type: Boolean,
            default: false,
        },
      },
      data() {
        return {
          trans: trans,
          busy: false,
          error: null,
          selected_id: this.value,
          categories: [],
          currentItem: {},
        }
      },
      components: {
        ModelTreeselect,
        DynamicFormObj: () => import('./DynamicForm.vue'),
        ReorderModal
      },
      watch: {
        selected_id() {
            this.$emit('input', this.selected_id);
        },
        value() {
            this.selected_id = this.value;
        },
      },
      methods: {
        onReordered() {
            this.$refs.selectModel.load()
        },
        onOrder() {
            this.$bvModal.show(`${this.id}-dynamic-select-order-modal`);
        },
        onShown() {
          this.busy = false
          this.error = null
        },
        onSave(e) {
            e.preventDefault()
            // check validation
            if (this.validation && !this.$refs.dynamicForm.$refs.form.reportValidity()) {
                return;
            }

            this.busy = true
            this.error = null

            let url = this.url;
            const method = this.currentItem.id ? 'patch' : 'post'
            if (this.currentItem.id) url += `/${this.currentItem.id}`

            let data = this.currentItem

            // check fields if contains beforeSave method
            this.fields.map(field => {
                if (field.beforeSave) {
                    data[field.key] = field.beforeSave(data[field.key])
                }
            })

            if (this.extraData) {
                data = {...this.extraData, ...data};
            }

            if (!!this.extraUrl && this.extraUrl == '?type=class' && !data.type) {
                data.type = 'class'
            }

            return axios[method](url, data)
            .then(response => {
                this.busy = false
                _.toastSuccess(this, trans('saved_with_success'))
                this.$refs.selectModel.load().then(() => {
                    if (this.multiple) {
                        if (!this.selected_id.includes(response.data.id)) {
                            this.selected_id.push(response.data.id)
                        }
                    } else {
                        this.selected_id = response.data.id
                    }
                })
                this.$nextTick(() => {
                    this.$bvModal.hide(`${this.id}-dynamic-select-modal`)
                })
                this.$emit('saved', response.data);
            })
            .catch(error => {
                this.busy = false
                this.items = []
                this.error = _.errorFromAjax(error)
                _.toastError(this, this.error)
                this.$bvModal.hide(`${this.id}-dynamic-select-modal`)
            })
        },
        onAdd(e){
            this.currentItem = {}
            this.$bvModal.show(`${this.id}-dynamic-select-modal`);
        },
        onModify(item){
            let current = this.findWithChild(this.$refs.selectModel.items, item.id)
            // check fields if contains beforeShow method
            this.fields.map(field => {
                if (field.beforeShow) {
                   current[field.key] = field.beforeShow(current[field.key])
                }
            })
            this.currentItem = current
            this.$bvModal.show(`${this.id}-dynamic-select-modal`);
        },
        onDelete(item){
            this.$bvModal.msgBoxConfirm(this.deleteMsg ?? trans('archive_confirm'), {
                title: trans(this.type),
                okTitle: trans('archive'),
                okVariant: 'danger',
                cancelTitle: trans('cancel'),
            }).then(confirmed => {
            if (!confirmed) return
                let url = this.url + `/${item.id}`;
                axios.delete(url)
                .then(response => {
                    this.$bvToast.toast(response.data.message, {
                        title: trans('success'),
                        variant: 'success',
                        solid: true,
                    })
                    if (this.multiple && this.selected_id.includes(item.id)) {
                        this.selected_id = this.selected_id.filter(i => i != item.id)
                    } else if (this.selected_id == item.id) {
                        this.selected_id =  0
                    }
                    this.$refs.selectModel.load()
                })
                .catch(error => {
                    this.error = _.errorFromAjax(error)
                    _.toastError(this, this.error)
                    this.$refs.selectModel.load()
                })
            })
        },
        findWithChild(array, id){
            var result;
            array.some(o => result = o.id === id ? o : this.findWithChild(o.children || [], id));
            return result;
        },
        onAddChild(item){
            let current = this.findWithChild(this.$refs.selectModel.items, item.id)
            if(current){
                this.currentItem = {
                    parent_id: current.id,
                }
                this.$bvModal.show(`${this.id}-dynamic-select-modal`);
            }
        }
      },
      mounted() {
        window.dynamicSelect = this
      },
    }
  </script>
